export const transportAndStorageLocation = "/cliring/transportandstorage";
